<div>
  <div class="content-container">
    <div>@if (showCheckbox) {
      <h1 mat-dialog-title>Important Information</h1>
    }</div>
    <span class="content-span full-width" [ngClass]="{'bigger-font': showCheckbox}">{{ confirmMessage }}</span>
    @if (showCheckbox) {
      <div class="checkbox-container">
        <input type="checkbox" id="acknowledgeCheckbox" [(ngModel)]="isCheckboxChecked"/>
        <label for="acknowledgeCheckbox" > I have read and understand that I need to make sure by checking FN3 that the Medications have been processed successfully</label>
      </div>
    }
  </div>
  <button mat-flat-button color="primary" id="yes-button" (click)="closeDialog(true)">Confirm</button>
  <button mat-flat-button color="warn" id="no-button" (click)="closeDialog(false)">Cancel</button>
</div>
